// ============================================================================
// FILE: src/modules/uploads/components/wizard/ConfigureStep.jsx
// MODULE: Generic Upload Framework
//
// PURPOSE:
// Upload Wizard - Configure Step.
//
// RESPONSIBILITIES:
// - Display Module
// - Display Entity
// - Display Upload Type
// - Display Description
// - Raise Upload Type Change Event
//
// NOTES:
// - UI Only
// - No API Calls
// - No Business Logic
// ============================================================================
//
// AUTHOR:
// DizyPro ERP Development Team
// ============================================================================

import React from "react";

import PropTypes from "prop-types";

const ConfigureStep = ({

    wizard,

    onUploadTypeChange

}) => {

    // =====================================================================
    // Handlers
    // =====================================================================

    const handleUploadTypeChange = (event) => {

        onUploadTypeChange(

            event.target.value

        );

    };

    // =====================================================================
    // Render
    // =====================================================================

    return (

        <div className="upload-configure-step">

            <div className="upload-card">

                <div className="upload-card-header">

                    <h4>

                        Configure Upload

                    </h4>

                </div>

                <div className="upload-card-body">

                    {/* -------------------------------------------------- */}
                    {/* Module */}
                    {/* -------------------------------------------------- */}

                    <div className="form-group">

                        <label>

                            Module

                        </label>

                        <input

                            type="text"

                            className="form-control"

                            value={wizard.moduleName}

                            readOnly

                        />

                    </div>

                    {/* -------------------------------------------------- */}
                    {/* Entity */}
                    {/* -------------------------------------------------- */}

                    <div className="form-group">

                        <label>

                            Entity

                        </label>

                        <input

                            type="text"

                            className="form-control"

                            value={wizard.entityName}

                            readOnly

                        />

                    </div>

                    {/* -------------------------------------------------- */}
                    {/* Upload Type */}
                    {/* -------------------------------------------------- */}

                    <div className="form-group">

                        <label>

                            Upload Type

                        </label>

                        <select

                            className="form-select"

                            value={

                                wizard.selectedUploadType

                            }

                            onChange={

                                handleUploadTypeChange

                            }

                        >

                            <option value="">

                                Select Upload Type

                            </option>

                            {

                                wizard.uploadTypes.map(

                                    uploadType => (

                                        <option

                                            key={

                                                uploadType.value

                                            }

                                            value={

                                                uploadType.value

                                            }

                                        >

                                            {

                                                uploadType.label

                                            }

                                        </option>

                                    )

                                )

                            }

                        </select>

                    </div>
                                        {/* -------------------------------------------------- */}
                    {/* Description */}
                    {/* -------------------------------------------------- */}

                    <div className="form-group">

                        <label>

                            Description

                        </label>

                        <textarea

                            className="form-control"

                            rows={3}

                            value={wizard.description || ""}

                            readOnly

                        />

                    </div>

                    {/* -------------------------------------------------- */}
                    {/* Instructions */}
                    {/* -------------------------------------------------- */}

                    <div className="upload-instructions">

                        <h5>

                            Instructions

                        </h5>

                        <ul>

                            <li>

                                Select the appropriate Upload Type.

                            </li>

                            <li>

                                Download the template in the next step.

                            </li>

                            <li>

                                Populate the template without modifying the
                                column headers.

                            </li>

                            <li>

                                Upload the completed Excel file.

                            </li>

                            <li>

                                Validation is performed during upload.

                            </li>

                            <li>

                                Review validation results before proceeding.

                            </li>

                        </ul>

                    </div>

                </div>

            </div>

        </div>

    );

};

ConfigureStep.propTypes = {

    wizard: PropTypes.shape({

        moduleCode: PropTypes.string,

        moduleName: PropTypes.string,

        entityCode: PropTypes.string,

        entityName: PropTypes.string,

        title: PropTypes.string,

        description: PropTypes.string,

        uploadTypes: PropTypes.arrayOf(

            PropTypes.shape({

                value: PropTypes.string.isRequired,

                label: PropTypes.string.isRequired

            })

        ),

        selectedUploadType: PropTypes.string

    }).isRequired,

    onUploadTypeChange: PropTypes.func.isRequired

};

export default ConfigureStep;